import { createContext, useContext, useState, ReactNode } from "react";
import { AlertAction, AlertType } from "src/components/ui/alerts/AlertDialog";
import AlertDialogs from "src/components/ui/alerts/AlertDialog";

type AlertState = {
    type : AlertType,
    title? : string,
    description? : string,
    action?:AlertAction
}

type AlertContextType = {
  showAlert: (type: AlertType, title?: string, description?: string, action?:AlertAction) => void
  showSuccess: (title?: string, description?: string) => void
  showError: (title?: string, description?: string) => void
  showWarning: (title?: string, description?: string, action?:AlertAction) => void
}

export const AlertContext = createContext<AlertContextType | null>(null);

export function AlertProvider({ children }: { children: ReactNode }) {
    const [open, setOpen] = useState(false);
    const [alert, setAlert] = useState<AlertState | null>(null);

    function showAlert(type: AlertType, title?: string, description?: string, action?:AlertAction) {
        setAlert({ type, title, description, action })
        setOpen(true)
    }

    function showSuccess(title?: string, description?: string) {
        showAlert("success", title, description)
    }

    function showError(title?: string, description?: string) {
        showAlert("error", title, description)
    }

    function showWarning(title?: string, description?: string, action?:AlertAction) {
        showAlert("warning", title, description, action)
    }

    return(
        <AlertContext.Provider value={{showAlert, showError, showSuccess, showWarning}}>
            {children}

            { alert &&
            <AlertDialogs
                type={alert.type}
                open={open}
                onOpenChange={setOpen}
                title={alert.title}
                description={alert.description}
                action={alert.action}
            />
            }
        </AlertContext.Provider>
    )
}